import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import React from 'react'

const SocialIcon = ({
  icon, href
}) => (
  <a className='social-icon' href={href} target='_blank' rel='noopener noreferrer'>
    <FontAwesomeIcon icon={['fab', icon]} />
  </a>
)

SocialIcon.propTypes = {
  icon: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired
}

export default SocialIcon
